import type { SiteId } from '@/features/basket/types/site';

export enum TestsNames {
  LEAVE_REVIEWS_TEST = 'leave_reviews_test',
}

export enum OnOffOptions {
  ON = 'on',
  OFF = 'off',
}

export enum ABOptions {
  A = 'a',
  B = 'b',
}

export interface TestOptionsMap {
  [TestsNames.LEAVE_REVIEWS_TEST]: ABOptions;
}

export type TestOptions = TestOptionsMap[TestsNames];

export interface Test {
  name: TestsNames;
  value: TestOptions;
}

export type TestEnvironment = 'development' | 'production';

export interface TestConfig {
  name: TestsNames;
  options: TestOptions[];
  enabled: boolean;
  siteIds?: SiteId[];
  defaultValue: TestOptions;
  callback?: (testVariant: TestOptions, data?: unknown) => void;
  environment?: TestEnvironment;
}
